import { TableColumn } from '../models/table-column';

export interface QueryParams {
  [key: string]: string | number | number[] | boolean | null | undefined;
}

export const buildQueryString = <T extends QueryParams>(
  query: Partial<T>
): string => {
  const queryParams = [];

  for (const key in query) {
    if (query.hasOwnProperty(key) && query[key] != null && query[key] !== '') {
      queryParams.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(
          query[key] as string | number | boolean
        )}`
      );
    }
  }

  return queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
};

export const buildFilterInfo = <T>(
  params: T,
  values: TableColumn[],
  filterValue: string,
  schema: any
): T => {
  if (values && filterValue) {
    for (const item of values) {
      if (item.selected) {
        let name = item.name;
        if (item?.stringFilterName) {
          name = item.stringFilterName;
        }

        if (schema[name] === 'string') {
          params[name] = filterValue;
        }
      }
    }
  }
  return params;
};
